import { ExclamationTriangle, ExclamationTriangleSolid } from '@assets/svgs';
import { Tooltip } from '@components/tooltip/Tooltip';

import { PolicySearchResponse } from '@lio/api-types';
import { Box } from '@mui/system';
import { fakeLocalMidnightFromTZMidnight, ShortDateFormat } from '@utils/date';
import { format } from 'date-fns-tz';

export type OpenSubjectivityColumnProps = {
  openSubjectivities?: PolicySearchResponse['items'][number]['subjectivities'];
};

export const OpenSubjectivityColumn = ({ openSubjectivities }: OpenSubjectivityColumnProps) => {
  const hasOpenSubjectivities = openSubjectivities && openSubjectivities.length > 0;

  return (
    <Box
      sx={{
        height: '100%',
        opacity: hasOpenSubjectivities ? 1 : 0.3,
        padding: 0,
      }}
    >
      {hasOpenSubjectivities ? (
        <Tooltip
          sx={{
            fontSize: '12px',
          }}
          title={
            <Box
              sx={{
                ' li': {
                  paddingLeft: '16px', // Indent all lines
                  textIndent: '-16px', // Pull first line back
                },
              }}
            >
              {openSubjectivities.map((subjectivity) =>
                subjectivity.dueBy ? (
                  <li key={subjectivity.id}>
                    {subjectivity.label} - Due By{' '}
                    {format(fakeLocalMidnightFromTZMidnight(subjectivity.dueBy), ShortDateFormat)}
                  </li>
                ) : (
                  <li key={subjectivity.id}>{subjectivity.label}</li>
                ),
              )}
            </Box>
          }
        >
          <Box sx={{ height: '100%', color: 'secondary.main' }}>
            <ExclamationTriangleSolid width='16px' height='auto' />
          </Box>
        </Tooltip>
      ) : (
        <ExclamationTriangle width='16px' height='auto' />
      )}
    </Box>
  );
};
